// Translations
export const T = {
  en_GB: {
    copy: "Copy",
    copied: "Copied",
    editPrompts: "Edit prompts",
    sendMessage: "Send message",
    stopGenerating: "Stop generating",
    aiAgent: "Global Agent",
    systemAi: "Design Agent",
    greetingSystem:
      "I help you set up portfolio collections and products. Ask me to list a collection, inspect a product's configuration, or add a new one.",
    noThreadsSystem: "No system AI conversations yet",
    clear: "Clear",
    newThread: "New chat",
    threads: "Threads",
    back: "Back",
    noThreadsGlobal: "No conversations yet",
    greetingGlobal:
      "I can help you find clients, get an overview, answer questions about the platform, and more.",
    noThreadsClient: "No conversations about this client yet",
    greetingClient:
      "I can help you with this client — ask about their details, flows, documents, and more.",
    loadThreadsFailed: "Couldn't load conversations",
    retry: "Retry",
    tryAsking: "Try asking:",
    // Global examples — leverage client tools, charts, news, docs, mail
    exampleGlobalBreakdown: {
      label: "Pie chart: clients by type",
      send: "Show me a pie chart with the breakdown of all my clients by client type.",
    },
    exampleGlobalRecentActivity: {
      label: "This week's activity",
      send: "Summarise this week's meetings, calls and notes across all my clients. Show the activity widgets.",
    },
    exampleGlobalNewsRadar: {
      label: "News on top clients' holdings",
      send: "Find news from the last 7 days that's relevant to the largest holdings of my top 10 clients by AUM. Group by client.",
    },
    exampleGlobalDocsSearch: {
      label: "How do I set up risk assessment?",
      send: "Search the platform docs for how to configure a risk assessment flow and link the relevant pages.",
    },
    exampleGlobalEninLookup: {
      label: "Enin: look up Volvo (SE)",
      send: "Search Enin for 'Volvo' in Sweden, pick the parent company, and summarise the latest accounting highlights and ultimate beneficial owners.",
    },
    exampleGlobalDormantClients: {
      label: "Dormant clients — draft outreach",
      send: "List clients I haven't logged a call, meeting or note for in the last 90 days, then draft a short outreach email I can send to each.",
    },
    // Client examples — leverage flows, products, wealth plan, accounts, files, mail, enin
    exampleClient360: {
      label: "360° client overview",
      send: "Give me a 360° overview of this client: contact info, accounts, active flows, recent notes/calls/meetings, and any files. Use widgets where it helps.",
    },
    exampleClientWealth: {
      label: "Wealth plan + holdings chart",
      send: "Summarise this client's wealth plan and show a pie chart of holdings by asset class.",
    },
    exampleClientFlowStatus: {
      label: "Active flows — what's pending?",
      send: "List this client's active flow instances and tell me what's still pending or blocked on each one.",
    },
    exampleClientMeetingPrep: {
      label: "Prep for next meeting",
      send: "Draft an agenda for my next meeting with this client based on recent notes, calls, open flows and unresolved items.",
    },
    exampleClientEnin: {
      label: "Enin company snapshot",
      send: "Pull this client's company from Enin and summarise the latest financials, ownership and any risk signals.",
    },
    exampleClientMail: {
      label: "Recent emails from client",
      send: "Search my IMAP inbox for the latest emails from this client and summarise the open threads.",
    },
    // System examples — leverage system_portfolio_collection_read, system_product_read,
    // system_product_manage and system_instrument_read
    exampleSystemCollections: {
      label: "Collections overview",
      send: "List my portfolio collections with their risk model, currency and product count.",
    },
    exampleSystemProductDetail: {
      label: "Product — full config",
      send: "Show me the full configuration of one product: suitability, cost values, asset allocation and documents.",
    },
    exampleSystemAllocationAudit: {
      label: "Find unallocated products",
      send: "Scan a collection and list products whose asset allocation doesn't sum to 100 — or is missing entirely.",
    },
    exampleSystemCreateProduct: {
      label: "Add a product from an instrument",
      send: "Search for an instrument by ISIN and create a product from it in my collection.",
    },
    askQuestion: "Ask a question...",
    voiceStart: "Voice to text (Voxtral)",
    voiceStop: "Stop & transcribe",
    voiceError: "Transcription failed. Please try again.",
    voiceMicDenied: "Microphone access was denied.",
    voiceLanguage: "Transcription language",
    errorMessage: "Sorry, I encountered an error. Please try again.",
    unread: "Unread",
    retryAction: "Retry",
    errorHeadline: {
      auth: "The AI provider rejected the request (authentication)",
      credits: "The AI provider account is out of credits",
      tool_limit: "Too many tools enabled for this model",
      context_overflow: "This conversation is too long for the model",
      rate_limited: "Too many requests right now",
      timeout: "The AI provider took too long to respond",
      provider_down: "The AI provider is having problems",
      unknown: "Something went wrong while generating the response",
    },
    errorHint: {
      auth: "This is usually a temporary provider issue — retry in a moment.",
      credits: "Ask your administrator to top up or switch the AI provider.",
      tool_limit: "Disable some MCP servers or pick a different model.",
      context_overflow: "Start a new chat to continue.",
      rate_limited: "Wait a moment before retrying.",
      timeout: "Retry — a different attempt often succeeds.",
      provider_down: "Retry shortly.",
      unknown: "Retry — if it keeps failing, contact support.",
    },
    tokens: "tokens",
    tool: "tool",
    tools: "tools",
    untitled: "Untitled chat",
    deleteConfirm: "Delete this thread?",
    markAllRead: "Mark all read",
    visibilityPrivate: "Only visible to you",
    visibilityShared: "Shared with your team",
    attachFile: "Attach file",
    uploading: "Uploading…",
    uploadFailed: "Upload failed",
    statusQueued: "Queued",
    statusTranscribing: "Transcribing…",
    statusReady: "Ready",
    statusFailed: "Failed",
    waitingForFiles: "Waiting for transcription to finish…",
  },
  nb_NO: {
    copy: "Kopier",
    copied: "Kopiert",
    editPrompts: "Rediger forslag",
    sendMessage: "Send melding",
    stopGenerating: "Stopp generering",
    aiAgent: "Global agent",
    systemAi: "Designagent",
    greetingSystem:
      "Jeg hjelper deg med å sette opp porteføljesamlinger og produkter. Be meg liste en samling, se på et produkts konfigurasjon, eller legge til et nytt.",
    noThreadsSystem: "Ingen system-AI-samtaler ennå",
    clear: "Tøm",
    newThread: "Ny chat",
    threads: "Tråder",
    back: "Tilbake",
    noThreadsGlobal: "Ingen samtaler ennå",
    greetingGlobal:
      "Jeg kan hjelpe deg med å finne kunder, få oversikt, svare på spørsmål om plattformen, og mer.",
    noThreadsClient: "Ingen samtaler om denne kunden ennå",
    greetingClient:
      "Jeg kan hjelpe deg med denne kunden — spør om detaljer, flyter, dokumenter og mer.",
    loadThreadsFailed: "Kunne ikke laste samtaler",
    retry: "Prøv igjen",
    tryAsking: "Prøv å spørre:",
    exampleGlobalBreakdown: {
      label: "Kakediagram: kunder etter type",
      send: "Vis meg et kakediagram med fordelingen av alle mine kunder etter kundetype.",
    },
    exampleGlobalRecentActivity: {
      label: "Aktivitet denne uken",
      send: "Oppsummer denne ukens møter, samtaler og notater på tvers av alle mine kunder. Vis aktivitets-widgets.",
    },
    exampleGlobalNewsRadar: {
      label: "Nyheter om topp-kunders beholdninger",
      send: "Finn nyheter fra de siste 7 dagene som er relevante for de største beholdningene til mine 10 største kunder etter AUM. Grupper per kunde.",
    },
    exampleGlobalDocsSearch: {
      label: "Hvordan setter jeg opp risikoprofilering?",
      send: "Søk i plattformdokumentasjonen etter hvordan man konfigurerer en risikoprofileringsflyt og lenk til de relevante sidene.",
    },
    exampleGlobalEninLookup: {
      label: "Enin: slå opp Volvo (SE)",
      send: "Søk i Enin etter 'Volvo' i Sverige, velg morselskapet, og oppsummer siste regnskapstall og ultimate eiere.",
    },
    exampleGlobalDormantClients: {
      label: "Inaktive kunder — utkast til oppfølging",
      send: "List opp kunder jeg ikke har loggført samtale, møte eller notat på de siste 90 dagene, og skriv så et kort oppfølgings-e-postutkast til hver.",
    },
    exampleClient360: {
      label: "360°-oversikt for kunde",
      send: "Gi meg en 360°-oversikt over denne kunden: kontaktinfo, kontoer, aktive flyter, nylige notater/samtaler/møter og eventuelle filer. Bruk widgets der det hjelper.",
    },
    exampleClientWealth: {
      label: "Formuesplan + kakediagram",
      send: "Oppsummer denne kundens formuesplan og vis et kakediagram over beholdninger fordelt på aktivaklasse.",
    },
    exampleClientFlowStatus: {
      label: "Aktive flyter — hva venter?",
      send: "List opp denne kundens aktive flyt-instanser og fortell hva som fortsatt er åpent eller blokkert i hver av dem.",
    },
    exampleClientMeetingPrep: {
      label: "Forbered neste møte",
      send: "Lag et agenda-utkast til mitt neste møte med denne kunden basert på nylige notater, samtaler, åpne flyter og uavklarte punkter.",
    },
    exampleClientEnin: {
      label: "Enin selskapsbilde",
      send: "Hent denne kundens selskap fra Enin og oppsummer siste regnskap, eierskap og risikosignaler.",
    },
    exampleClientMail: {
      label: "Siste e-poster fra kunden",
      send: "Søk i IMAP-innboksen min etter de siste e-postene fra denne kunden og oppsummer åpne tråder.",
    },
    exampleSystemCollections: {
      label: "Oversikt over samlinger",
      send: "List porteføljesamlingene mine med risikomodell, valuta og antall produkter.",
    },
    exampleSystemProductDetail: {
      label: "Produkt — full konfigurasjon",
      send: "Vis meg full konfigurasjon for ett produkt: egnethet, kostnadsverdier, aktivaallokering og dokumenter.",
    },
    exampleSystemAllocationAudit: {
      label: "Finn produkter uten allokering",
      send: "Skann en samling og list produkter der aktivaallokeringen ikke summerer til 100 — eller mangler helt.",
    },
    exampleSystemCreateProduct: {
      label: "Legg til produkt fra instrument",
      send: "Søk etter et instrument med ISIN og opprett et produkt fra det i samlingen min.",
    },
    askQuestion: "Still et spørsmål...",
    voiceStart: "Tale til tekst (Voxtral)",
    voiceStop: "Stopp og transkriber",
    voiceError: "Transkripsjon feilet. Prøv igjen.",
    voiceMicDenied: "Mikrofontilgang ble avvist.",
    voiceLanguage: "Transkripsjonsspråk",
    errorMessage: "Beklager, jeg støtte på en feil. Vennligst prøv igjen.",
    unread: "Ulest",
    retryAction: "Prøv igjen",
    errorHeadline: {
      auth: "AI-leverandøren avviste forespørselen (autentisering)",
      credits: "AI-leverandørens konto er tom for kreditter",
      tool_limit: "For mange verktøy aktivert for denne modellen",
      context_overflow: "Denne samtalen er for lang for modellen",
      rate_limited: "For mange forespørsler akkurat nå",
      timeout: "AI-leverandøren brukte for lang tid på å svare",
      provider_down: "AI-leverandøren har problemer",
      unknown: "Noe gikk galt under genereringen av svaret",
    },
    errorHint: {
      auth: "Dette er vanligvis et midlertidig leverandørproblem — prøv igjen om litt.",
      credits: "Be administratoren fylle på eller bytte AI-leverandør.",
      tool_limit: "Deaktiver noen MCP-servere eller velg en annen modell.",
      context_overflow: "Start en ny chat for å fortsette.",
      rate_limited: "Vent et øyeblikk før du prøver igjen.",
      timeout: "Prøv igjen — et nytt forsøk lykkes ofte.",
      provider_down: "Prøv igjen om litt.",
      unknown: "Prøv igjen — kontakt support hvis det fortsetter å feile.",
    },
    tokens: "tokens",
    tool: "verktøy",
    tools: "verktøy",
    untitled: "Uten tittel",
    deleteConfirm: "Slett denne tråden?",
    markAllRead: "Marker alle som lest",
    visibilityPrivate: "Kun synlig for deg",
    visibilityShared: "Delt med teamet ditt",
    attachFile: "Legg ved fil",
    uploading: "Laster opp…",
    uploadFailed: "Opplasting feilet",
    statusQueued: "I kø",
    statusTranscribing: "Transkriberer…",
    statusReady: "Klar",
    statusFailed: "Feilet",
    waitingForFiles: "Venter på at transkripsjon fullføres…",
  },
} as const;
